module.exports = __webpack_public_path__ + "img/reset password logo and illustration.34cfc68c.svg";